import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="container-r360 py-32 text-center">
      <div className="mono-label mb-4">// 404</div>
      <h1 className="reveal-on-scroll text-[96px] leading-none font-display">NOT FOUND.</h1>
      <p className="reveal-on-scroll text-[#8a8a8a] mt-6 max-w-md mx-auto">
        That page doesn't exist — but your recoverable revenue still does.
      </p>
      <Link to="/" className="btn btn-primary mt-8 inline-flex">
        Back home →
      </Link>
    </div>
  );
}
